import { createFileRoute } from "@tanstack/react-router";

import { FinancialsPage } from "@/features/insights/financials";

export const Route = createFileRoute("/_authenticated/intel/financials")({
  component: FinancialsPage,
});
